module.exports = __webpack_public_path__ + "static/media/filter-icon.5fc6be25.svg";